export default (str) => {
    if (!str || str.indexOf(" ") == -1) {
        return str;
    }
  
    var chunks = str.split(" ");
    return reverseDate(chunks[0]);
}

function reverseDate(str) {
    var chunks = str.split("-");
    chunks = chunks.reverse(chunks);  
    return chunks.join("/");
}